import CheckCircle from "@untitled-ui/icons-react/build/esm/CheckCircle";
import styled from "styled-components";

// #region SCOPED CSS
const StyledActivationContent = styled.div`
    color: var(--text-icons-gray-100, #d1d1d1);
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .activation-description,
    .activation-follow-up {
        font-size: 16px;
        line-height: 24px;
        text-align: center;
    }

    .activation-details {
        align-self: stretch;
        background: var(--backgrounds-lines-n-600, #10141b);
        border-radius: 4px;
        margin-top: 18px;
        padding: 18px 20px 24px;
    }

    .activation-details-title {
        color: var(--text-icons-green-500, #00bb00);
        font-size: 16px;
        font-weight: 700;
        line-height: 25px;
        margin-bottom: 18px;
        text-align: center;
    }

    .activation-details-list {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .activation-details-item {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 16px;
        line-height: 24px;
        text-align: left;
    }

    .activation-details-icon {
        color: var(--text-icons-green-500, #00bb00);
        flex-shrink: 0;
        height: 24px;
        width: 24px;
    }

    .activation-follow-up {
        margin: 24px 0 18px;
    }

    @media (max-width: 600px) {
        .activation-description,
        .activation-follow-up,
        .activation-details-title {
            font-size: 15px;
            line-height: 22px;
        }

        .activation-details {
            padding: 16px;
        }

        .activation-details-item {
            font-size: 14px;
            line-height: 20px;
        }

        .activation-details-icon {
            height: 20px;
            width: 20px;
        }
    }
`;
// #endregion SCOPED CSS

/** Renders the plan-specific content inside the activation-success popup. */
export default function ContentSubscriptionActivation({ activationSuccess }) {
    return (
        <StyledActivationContent>
            <div className="activation-description">{activationSuccess.description}</div>

            <div className="activation-details">
                <div className="activation-details-title">{activationSuccess.detailsTitle}</div>
                <div className="activation-details-list">
                    {activationSuccess.details.map(item => (
                        <div className="activation-details-item" key={item}>
                            <CheckCircle className="activation-details-icon" />
                            <span>{item}</span>
                        </div>
                    ))}
                </div>
            </div>

            <div className="activation-follow-up">{activationSuccess.followUp}</div>
        </StyledActivationContent>
    );
}
